export class Tab {
  name: string;
  contentUrl: string;
  selected: boolean;

  constructor(name: string, contentUrl: string, selected: boolean = false) {
    this.name = name;
    this.contentUrl = contentUrl;
    this.selected = selected;
  }
}
